import {PaymentSavedView} from '@app/shared/models/PaymentSavedView';
import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {MacroGroupsService} from '@app/services/net-remit/macro-groups.service';
import {PaymentsService} from '@app/services/net-remit/payments.service';
import {SharedDataService} from '@app/services/net-remit/shared-data.service';
import {RemoteAccountService} from '@app/services/net-remit/remote-account.service';
import {MessageService as PrimeMessageService} from 'primeng/api';

import {RemoteAccountView} from '@app/shared/views/RemoteAccountView';
import {AgentsMacroGroupView} from '@app/shared/views/AgentsMacroGroupView';
import {MemoPaymentView} from '@app/shared/views/MemoPaymentView';

import {PaymentFormComponent} from "@app/payment-management/payment-form/payment-form.component";

import {routesConstants} from '@app/shared/models/LinksView';
import {finalize, takeWhile} from 'rxjs/operators';
import {default as constantsFile} from '@app/shared/constants.json';
import {forkJoin} from 'rxjs';
import {fadeIn} from 'assets/animations/animations';

@Component({
    selector: 'app-payment-task-detail',
    templateUrl: './payment-task-detail.component.html',
    styleUrls: ['./payment-task-detail.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class PaymentTaskDetailComponent implements OnInit, AfterViewChecked{

  alive: boolean = true;
  customerId: number;
  defaultMaxRelated: number;
  diffCountry: string;
  diffValueMaxRelated: number;
  enableRemotes: boolean;
  endTaskDateNotHigherThanStartDate: boolean;
  endTaskDateNotHigherThanToday: boolean;
  hasError: boolean;
  isLoading: boolean = true;
  isLoadingRemotes: boolean;
  isMaxRelatedHigherMax: boolean;
  isMaxRelatedZero: boolean;
  isTaskEditable: boolean;
  maxRelatedAllowed: number;
  paymentId: number;
  paymentFormChanged: boolean;
  remoteResponseList: Array<RemoteAccountView>;
  savingOk: boolean;
  uploadRemoteList: Array<RemoteAccountView>;

  agentsMacroGroupsList: Array<AgentsMacroGroupView> = new Array<AgentsMacroGroupView>();
  memoPayment: MemoPaymentView;
  paymentSaved: PaymentSavedView;
  // OriginalState
  memoPaymentReset: MemoPaymentView;

  constants: any = constantsFile.constants;

  @ViewChild(PaymentFormComponent) paymentFormComponent: PaymentFormComponent;

// Access form via this.childComp.paymentForm

  fromDocValid: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private macroGroupsService: MacroGroupsService,
    private paymentsService: PaymentsService,
    private primeMessageService: PrimeMessageService,
    private router: Router,
    private sharedDataService: SharedDataService,
    private translateService: TranslateService,
    private remoteAccountService: RemoteAccountService
  ) { }

  ngOnInit(): void {
    this.paymentId = this.activatedRoute.snapshot.params['paymentId'];
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.initValues();
    this.getTaskDetailData();
  }

  public getTaskDetailData(){
    forkJoin([
      this.paymentsService.findTaskDetail(this.paymentId, this.customerId),
			this.sharedDataService.getMaxRelatedData(),
      this.macroGroupsService.getAgentsMacroGroupsByCustomer(this.customerId)
		])
    .pipe(takeWhile(() => this.alive))
    .subscribe({ next: ([data, mr, agentsMacroGroups]) => {
      this.agentsMacroGroupsList = agentsMacroGroups;
      this.setTaskData(data);

      this.diffCountry = mr.diffCountry;
      this.diffValueMaxRelated = mr.diffValueArc;

      if (data.bsp === this.diffCountry) {
        this.maxRelatedAllowed = this.defaultMaxRelated = mr.diffValueArc;
      } else {
        this.maxRelatedAllowed = this.defaultMaxRelated =  mr.defaultValue;
      }
      if (data.templateExpired != null) {
        this.primeMessageService.add({
          closable: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant('Task Template Expired')
        });
      }
    }, error: () => {
      this.hasError = true;
      this.primeMessageService.add({
        closable: true,
        severity:'error',
        summary: this.translateService.instant('Modal.Error'),
        detail: this.translateService.instant('Error Generic Onload')
      });
    }});
  }

  private setTaskData(data: MemoPaymentView){
    this.memoPayment = data;
    this.memoPayment.memoContentOrigin.messageKeyTranslated = this.translateService.instant(data.memoContentOrigin.messageKey);
    this.memoPayment.fromDocument = this.memoPayment.fromDocument.toString().padStart(10, "0");
    this.memoPayment.fromDocumentAdm = this.memoPayment.fromDocumentAdm.toString().padStart(10, "0");
    this.memoPayment.toDocument = this.memoPayment.toDocument.toString().padStart(10, "0");
    this.memoPayment.toDocumentAdm = this.memoPayment.toDocumentAdm.toString().padStart(10, "0");
    this.memoPayment.currentDocument = this.memoPayment.currentDocument?.toString().padStart(10, "0");
    this.memoPayment.currentDocumentAdm = this.memoPayment.currentDocumentAdm?.toString().padStart(10, "0");
    this.getRemotes();
  }

  protected initValues() {
    this.isTaskEditable = false;
    this.hasError = false;
    this.savingOk = false;
    this.paymentSaved = undefined;
  }

  protected goBack() {
    this.router.navigate([routesConstants.paymentManagement.paymentManagement]);
  }

  public maxRelatedSelection() {
    this.memoPayment.maxRelated = (!isNaN(this.memoPayment.maxRelated) && this.memoPayment.maxRelated.toString() !== "") ? Number(this.memoPayment.maxRelated) : this.memoPayment.maxRelated;

    // Establecer errores en función del valor escrito y país elegido
    this.isMaxRelatedZero = this.memoPayment.maxRelated === 0;
    this.isMaxRelatedHigherMax = this.memoPayment.maxRelated > this.maxRelatedAllowed;
  }

  protected editPage() {
    this.memoPaymentReset = structuredClone(this.memoPayment);
    this.isTaskEditable = true;
  }

  protected cancelPage() {
    this.isTaskEditable = false;
    this.memoPayment =  this.memoPaymentReset;
  }

  protected checkButtonSaveDisabled() {
    // Save button is disabled if the form is editable but there are no changes, if the form is not editable yet or if there is any error in it.
    return (!this.paymentFormComponent?.paymentForm.dirty && !this.paymentFormComponent?.periodicForm?.dirty && this.isTaskEditable) || !this.isTaskEditable ||
      this.paymentFormComponent?.paymentForm.invalid || this.paymentFormComponent?.periodicForm?.invalid || (this.fromDocValid && this.memoPayment.toDocument < this.memoPayment.fromDocument) ||
      this.isMaxRelatedHigherMax || this.isMaxRelatedZero || this.endTaskDateNotHigherThanStartDate || this.endTaskDateNotHigherThanToday;
  }

  protected setMemoPaymentToUpdate() {
    if (this.memoPayment.agentsMacroGroup?.agentsMacroGroupId == 0 || !this.memoPayment.agentsMacroGroup?.agentsMacroGroupId) {
      this.memoPayment.agentsMacroGroup = null;
    }
    if (this.memoPayment.remoteResponse?.id == 0 || !this.memoPayment.remoteResponse?.id) {
      this.memoPayment.remoteResponse = null;
    }
    if (this.memoPayment.startTaskDate != undefined) {
      this.memoPayment.startTaskDate = new Date(Date.UTC(this.memoPayment.startTaskDate.getFullYear(), this.memoPayment.startTaskDate.getMonth(), this.memoPayment.startTaskDate.getDate()));
    }
    if (this.memoPayment.endTaskDate != undefined) {
      this.memoPayment.endTaskDate = new Date(Date.UTC(this.memoPayment.endTaskDate.getFullYear(), this.memoPayment.endTaskDate.getMonth(), this.memoPayment.endTaskDate.getDate()));
    }
  }

  protected formatMemoPayment() {
    if (this.memoPayment.agentsMacroGroup == null) {
      this.memoPayment.agentsMacroGroup = new AgentsMacroGroupView();
    }
    if (this.memoPayment.remoteResponse == null) {
      this.memoPayment.remoteResponse = new RemoteAccountView();
    }
  }

  public savePayment() {
    this.savingOk = false;
    this.setMemoPaymentToUpdate();

    this.isLoading = true;
    this.paymentsService.updatePaymentTask(this.memoPayment)
      .pipe(takeWhile(() => this.alive))
      .subscribe({ next: paymentSaved => {
        this.savingOk = true;
        this.paymentId = paymentSaved.memoPaymentId;
        this.paymentSaved = paymentSaved;
        // Reload page with new PaymentId
        this.router.navigate([routesConstants.paymentManagement.paymentManagement + '/' + routesConstants.paymentManagement.taskDetail + '/' + this.paymentId + '/customer/' + this.customerId]);
        this.isTaskEditable = false;
        this.hasError = false;
        this.getMessageToast();
        this.getTaskDetailData();
      }, error: (error) => {
        this.formatMemoPayment();
        this.isLoading = false;

        this.isTaskEditable = false;
        this.hasError = true;
        this.primeMessageService.add({
          closable: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant(error.error)
        });
      }});
  }

  public getRemotes() {
    this.isLoadingRemotes = true;
    forkJoin([
      this.remoteAccountService.findRemotes(this.memoPayment.customer.customerId, this.memoPayment.airline.toString(), this.memoPayment.bsp, this.constants.remoteUseTypes.sftpUp),
      this.remoteAccountService.findRemotes(this.memoPayment.customer.customerId, this.memoPayment.airline.toString(), this.memoPayment.bsp, this.constants.remoteUseTypes.sftpDown)
    ])
    .pipe(finalize(() => { this.isLoading = false, this.isLoadingRemotes = false } ), takeWhile(() => this.alive))
    .subscribe( ([sftpUp, sftpDown]) => {
      this.setEnableRemotes(true);
      this.uploadRemoteList = sftpUp;
      this.remoteResponseList = sftpDown;
    });
  }

  public setEnableRemotes(value: boolean){
    //Method created because in payment-form is required to change this value at emptying remotes
    this.enableRemotes = value;
  }

  public setEndTaskDateNotHigherThanStartDate(){
    this.endTaskDateNotHigherThanStartDate = (this.memoPayment.endTaskDate != null && this.memoPayment.startTaskDate > this.memoPayment.endTaskDate);
  }

  public setEndTaskDateNotHigherThanToday(){
    this.endTaskDateNotHigherThanStartDate = (this.memoPayment.endTaskDate != undefined && this.memoPayment.startTaskDate > this.memoPayment.endTaskDate);
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    this.endTaskDateNotHigherThanToday = (this.memoPayment.endTaskDate != undefined && this.memoPayment.endTaskDate < (new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)));
  }

  private getMessageToast() {
    if (!this.paymentSaved.isEnabled) {
      this.primeMessageService.add({
        closable: true,
        severity:'success',
        summary: this.translateService.instant('Modal.Success'),
        detail: this.translateService.instant('There Will Be No Next Execution')
      });
    } else {
      if (this.paymentSaved.executeNow) {
        this.primeMessageService.add({
          closable: true,
          severity:'success',
          summary: this.translateService.instant('Modal.Success'),
          detail: this.translateService.instant('The Next Execution Will Be Within Few Seconds')
        });
      } else if (!this.paymentSaved.executeNow) {
        this.primeMessageService.add({
          closable: true,
          severity:'success',
          summary: this.translateService.instant('Modal.Success'),
          detail: this.translateService.instant('The Next Execution Will Be On', { param: this.paymentSaved.nextExecution })
        });
      }
    }
  }

  ngAfterViewChecked(){
    this.fromDocValid = document.getElementById("fromDoc")?.classList.contains("ng-valid");
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
		// prevent memory leak when component destroyed
    this.alive = false;
  }
}
